export enum Sort {
  A = 'a', //alphabetically
  P = 'p', //popularity
  HR = 'hr', //highest return
  R = 'r', //activation date
  RL = 'rl', //relevance
}
